import React, { useEffect } from "react";
import { ArrowRight, ShoppingBag, ShoppingCart } from "lucide-react";
import Card1Img from '../../../assets/images/landingPageCard1.jpg'
import Card2Img from '../../../assets/images/landingPageCard2.jpg'
import Card3Img from '../../../assets/images/landingPageCard3.jpg'
import Hen from "../../../assets/images/Hen.jpg";
import Goat from "../../../assets/images/goat.jpg";
import Cow from "../../../assets/images/cow.jpg";
import NewsLetter from "../../../components/newsletter/NewsLetter";
import { Eye, Heart } from "lucide-react";
import Testimonials from "../../../components/testimonials/Testimonials";
import { useNavigate } from "react-router-dom";
import { GetAllProductService } from "../../../services/ProductService";
import { useUser } from "../../../context/useUser";
import { BASE_URL } from "../../../constant";
import { useCart } from "../../../context/useCart";
import { useProducts } from "../../../context/useProducts";
import Mosque from '../../../assets/images/mosque.jpg'
import { useWishlist } from "../../../context/useWishList";
import LandingCarousel from "../../../components/carousel/LandingCarousel";
import { toast } from "sonner";
import Tooltip from '@mui/material/Tooltip';

function LandingPage() {
    const { country } = useUser()
    const navigate = useNavigate()
    const { productData, setProductData } = useProducts()
    const { addToCart } = useCart();
    const { addToWishlist } = useWishlist()
    const ChooseCookEnjoyCardsData = [
        {
            heading: "Mutton",
            subHeading: "Tender & Flavorful",
            text: "Savor premium-quality mutton, fresh and full of flavor perfect for every meal.",
            bgImage: Card1Img,
            link: "mutton",
        },
        {
            heading: "Beef",
            subHeading: "Juicy & Nutritious",
            text: "Enjoy tender, farm-fresh beef, perfect for steaks, curries and BBQ!",
            bgImage: Card2Img,
            link: "beef",
        },
        {
            heading: "Chicken",
            subHeading: "Fresh & Wholesome",
            text: "Savor juicy, antibiotic-free chicken-fresh and ready for every meal.",
            bgImage: Card3Img,
            link: "chicken",
        },
    ]

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await GetAllProductService();
                setProductData(response?.data || []);
            } catch (error) {
                console.error("Error fetching category data:", error);
                setProductData([]);
            }
        };
        fetchData();
    }, [setProductData]);

    const filteredHomeProducts = productData?.filter((item) => item?.showOnHomeScreen === true).slice(0, 10);
    const filteredChickenCategory = productData?.filter((item) => item?.whereToShow === "chicken").slice(0, 6);
    const filteredMuttonCategory = productData?.filter((item) => item?.whereToShow === "mutton").slice(0, 6);
    const filteredBeefCategory = productData?.filter((item) => item?.whereToShow === "beef").slice(0, 6);


    return (
        <main>
            <LandingCarousel />

            <div>
                <div className="max-w-[1300px] my-2 h-full mx-auto py-4 md:py-2 px-6 md:px-8 text-white">
                    <h1 className="font-[600] text-2xl text-[#1a1a1a] my-6 md:my-8 md:text-3xl">Choose, Cook, Enjoy!</h1>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[20px]">
                        {ChooseCookEnjoyCardsData.map((item, index) => (
                            <div
                                key={index}
                                className="h-[500px] w-full py-8 flex flex-col relative bg-cover bg-center"
                                style={{ backgroundImage: `url(${item?.bgImage})` }}
                            >
                                <div className="absolute inset-0 bg-black opacity-40"></div>
                                <div className="flex flex-col justify-between items-center h-full relative z-10">
                                    <div className="text-center px-4">
                                        <h1 className="font-[600] text-2xl text-[#fcfcfc] my-4 md:text-4xl">{item?.heading}</h1>
                                        <h1 className="font-[600] text-2xl text-[#fcfcfc] my-4 md:text-4xl">{item?.subHeading}</h1>
                                        <p className="font-[400] text-[#aaaba7] text-[15px] max-w-[270px] mx-auto">{item?.text}</p>
                                    </div>
                                    <div>
                                        <button onClick={() => { navigate(`/shop/${item?.link}`) }} className={`w-[170px] flex items-center justify-center gap-3 ${country === "PK" ? "text-[#8a2e25]" : "text-[#65754d]"}  font-[500] py-3.5 rounded-[40px] bg-white`}>
                                            <ArrowRight size={20} />Shop {item?.heading}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="max-w-[1300px] my-2  h-full mx-auto py-4 md:py-2 px-6 md:px-8 text-white">
                <h1 className="font-[600] text-2xl text-[#1a1a1a] px-3 my-6 md:my-8 md:text-3xl">Popular Products</h1>
                <div className="grid grid-cols-1 md:grid-cols-3 bg-white lg:grid-cols-4 p-5 gap-7 xl:grid-cols-4">
                    {Array.isArray(filteredHomeProducts) && filteredHomeProducts.map((item, index) => (
                        <div
                            key={index}
                            onClick={() => { navigate(`/product/description/${item?.id}?product=true`) }}
                            style={{ border: "1px solid rgb(210, 212, 215)" }}
                            className="min-h-[350px] cursor-pointer hover:z-10 bg-white transition-all duration-300 ease-in-out hover:shadow-sm hover:shadow-[#8a2e25] hover:scale-105 relative  group"
                        >
                            {/* Sale Tag */}
                            {item?.discountAtOnce ? (
                                <div className="bg-[#eb4b49] w-[70px] h-[25px] flex items-center justify-center py-1 rounded-sm absolute top-3 left-3">
                                    <p className="text-white text-[12px]">Sale {item?.discountAtOnce}%</p>
                                </div>
                            ) : (
                                country === "PK" ? (
                                    item?.IsDiscountedProductInPak ? (
                                        <div className="bg-[#eb4b49] w-[70px] h-[25px] flex items-center justify-center py-1 rounded-sm absolute top-3 left-3">
                                            <p className="text-white text-[12px]">Sale {item?.discountOfferinPak}%</p>
                                        </div>
                                    ) : (
                                        null
                                    )
                                ) : (
                                    item?.IsDiscountedProductInUSA ? (
                                        <div className="bg-[#eb4b49] w-[70px] h-[25px] flex items-center justify-center py-1 rounded-sm absolute top-3 left-3">
                                            <p className="text-white text-[12px]">Sale {item?.discountOfferinUSA}%</p>
                                        </div>
                                    ) : (
                                        null
                                    )
                                )
                            )}
                            <div className="absolute  top-3 right-3 flex md:flex-col gap-3 opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-opacity duration-300"
                            >
                                <Tooltip
                                    arrow
                                    title="Add to wishlist"
                                    placement="left"
                                    componentsProps={{
                                        tooltip: {
                                            sx: {
                                                backgroundColor: '#ffffff',
                                                color: '#000000',
                                                padding: '8px 12px',
                                                borderRadius: 0,
                                                boxShadow: 2,
                                                fontSize: '13px'
                                            },
                                            className: 'custom-tooltip',
                                        },
                                    }}
                                >
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            addToWishlist(item);
                                        }}
                                        className="bg-white cursor-pointer p-2 rounded-full shadow-md hover:bg-gray-100"
                                    >
                                        <Heart size={22} className="text-[#eb4b49]" />
                                    </button>
                                </Tooltip>
                                <Tooltip
                                    arrow
                                    title="View this product"
                                    placement="left"
                                    componentsProps={{
                                        tooltip: {
                                            sx: {
                                                backgroundColor: '#ffffff',
                                                color: '#000000',
                                                padding: '8px 12px',
                                                borderRadius: 0,
                                                boxShadow: 2,
                                                fontSize: '13px'
                                            },
                                            className: 'custom-tooltip',
                                        },
                                    }}
                                >
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            navigate(`/product/description/${item?.id}?product=true`);
                                        }}
                                        className="bg-white cursor-pointer p-2 rounded-full shadow-md hover:bg-gray-100">
                                        <Eye size={22} className="text-[#1a1a1a]" />
                                    </button>
                                </Tooltip>
                            </div>
                            {/* Product Image */}
                            <div className="flex max-h-[100%] items-center justify-center">
                                {
                                    item?.ProductImages?.[0]?.imageUrl ? <img src={BASE_URL + (item?.ProductImages?.[0]?.imageUrl?.replace(/^\/+/, ""))} className=" min-h-[200px] max-h-[200px]" alt="product-image" /> :
                                        <div className="w-full min-h-[200px] bg-slate-200"></div>
                                }
                            </div>

                            {/* Product Details */}
                            <div className="flex text-[#1a1a1a] py-4 px-3 justify-between items-center">
                                <div className="flex flex-col max-w-[170px] gap-[5px]">
                                    <h1 className={`text-[17px] text-[18px] ${country === "PK" ? "text-[#a6392b]" : "text-[#65754d]"}  font-[600]`}>
                                        {item?.productName}
                                    </h1>
                                    <h1 className="text-[19px] font-[600] relative inline-block">
                                        {
                                            country === "PK"
                                                ? `PKR ${item?.discountAtOnce
                                                    ? (item?.OriginalPricePak - (item?.OriginalPricePak * item?.discountAtOnce) / 100).toFixed(0)
                                                    : item?.IsDiscountedProductInPak
                                                        ? item?.PriceAfterDiscountPak
                                                        : item?.OriginalPricePak}`
                                                : `$${item?.discountAtOnce
                                                    ? (item?.OriginalPriceUSA - (item?.OriginalPriceUSA * item?.discountAtOnce) / 100).toFixed(0)
                                                    : item?.IsDiscountedProductInUSA
                                                        ? item?.PriceAfterDiscountUSA
                                                        : item?.OriginalPriceUSA}`
                                        }
                                        <span className="text-[19px] text-[#8f8f8f] font-[500] ml-2 relative inline-block">
                                            {country === "PK"
                                                ? (item?.discountAtOnce || item?.IsDiscountedProductInPak) && `PKR${item?.OriginalPricePak}`
                                                : (item?.discountAtOnce || item?.IsDiscountedProductInUSA) && `$${item?.OriginalPriceUSA}`
                                            }
                                            {(item?.discountAtOnce || (country === "PK" ? item?.IsDiscountedProductInPak : item?.IsDiscountedProductInUSA)) && (
                                                <svg
                                                    className="absolute left-0 top-1/2 w-full h-[2px] text-[#8f8f8f]"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <line x1="0" y1="1" x2="100%" y2="1" stroke="currentColor" strokeWidth="2" />
                                                </svg>
                                            )}
                                        </span>
                                    </h1>
                                    <h1 className="font-[600]">Category: <span className="font-[400]">{item?.Category?.categoryName}</span></h1>
                                    <h1 className="font-[600]">
                                        Tags: <span className="font-[400]">
                                            {item?.productTags ? item.productTags.split(',').join(', ') : "N/A"}
                                        </span>
                                    </h1>
                                </div>
                                <div>
                                    {(country === "PK"
                                        ? item?.quantityForPak > 0
                                        : item?.quantityForUSA > 0) ? (
                                        <Tooltip
                                            arrow
                                            title="Add to cart"
                                            placement="left"
                                            componentsProps={{
                                                tooltip: {
                                                    sx: {
                                                        backgroundColor: '#ffffff',
                                                        color: '#000000',
                                                        padding: '8px 12px',
                                                        borderRadius: 0,
                                                        boxShadow: 2,
                                                        fontSize: '13px'
                                                    },
                                                    className: 'custom-tooltip',
                                                },
                                            }}
                                        >
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    addToCart(item, country);
                                                }}
                                                className="bg-slate-200 absolute bottom-7 right-5 p-3 cursor-pointer rounded-full text-[#1a1a1a]"
                                            >
                                                <ShoppingCart size={20} />
                                            </button>
                                        </Tooltip>
                                    ) : (
                                        <div className="bg-red-100 absolute bottom-4 right-3 text-red-500 px-2 py-1 rounded-md text-sm font-medium">
                                            Out of stock
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>;
            </div>
            <div className="p-5">
                <div className="relative w-full max-w-[1250px]  mx-auto">
                    {/* Background Image */}
                    <div
                        className="relative w-full h-[250px] md:h-[350px] lg:h-[400px] rounded-xl overflow-hidden"
                        style={{ backgroundImage: `url(${Mosque})`, backgroundSize: "cover", backgroundPosition: "50% 100%" }}
                    >
                        {/* Overlay */}
                        <div className="absolute inset-0 bg-black/50 rounded-xl"></div>

                        {/* Content */}
                        <div className="absolute inset-0 flex pl-6 items-center justify-end pr-8 md:pr-12 lg:pr-16 text-white">
                            <div className="max-w-md">
                                <p className="text-[18px] uppercase tracking-wide text-gray-300">EID OFFER</p>
                                <h2 className="text-4xl md:text-6xl font-bold">
                                    <span className="text-[#ff8800]">Halal</span> Qurban
                                </h2>
                                <p className="mt-2 text-sm md:text-base text-gray-300">
                                    This Eid, fulfill your Qurbani with Halal-certified meat from Alif—fresh, ethical, and delivered hassle-free.
                                </p>

                                {/* Button */}
                                <button onClick={() => { navigate('/book-your-qurbani') }} className="mt-4 flex items-center justify-center gap-2 bg-white text-[#8c3129] px-7 py-3 rounded-full font-medium hover:bg-[#ff8800] hover:text-white transition">
                                    Book Qurbani <ArrowRight size={18} />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="max-w-[1300px] my-2  h-full mx-auto py-4 md:py-2 px-6 md:px-8 text-white">
                <h1 className="font-[600] text-2xl text-[#1a1a1a] my-6 md:my-8 md:text-3xl">Alif Chicken Products</h1>
                <div className="grid gap-5 grid-cols-12">
                    <div style={{ border: "1px solid rgb(210, 212, 215)" }} className="min-h-[560px] hover:z-10 bg-white transition-all duration-300 ease-in-out hover:shadow-sm hover:shadow-[#8a2e25] hover:scale-102 col-span-12 md:col-span-4">
                        <img src={Hen} alt="Category-img" />
                        <div className="p-3">
                            <h1 className={`font-[600] text-center text-2xl ${country === "PK" ? "text-[#8a2e25]" : "text-[#65754d]"} mt-6 mb-3"`}>Supreme Quality, Farm-Fresh Chicken!</h1>
                            <p className="text-[#969696] text-[14px] mb-3 text-center max-w-[450px] mx-auto">Our chickens are raised with utmost care, ensuring they stay healthy and free from harmful additives. Enjoy tender, nutritious and fresh chicken meat for every meal!</p>
                            <button onClick={() => { navigate('/shop/chicken') }} className={`${country === "PK" ? "bg-[#8a2e25]" : "bg-[#65754d]"} text-white mb-6 font-[500] p-3 justify-center flex items-center w-full max-w-[400px] gap-4 mx-auto rounded-[30px]`}>Shop Fresh Chicken Now <ShoppingBag /></button>
                        </div>
                    </div>
                    <div className="grid col-span-12 gap-5 p-5 md:p-0 md:col-span-8 grid-cols-1 md:grid-cols-3">
                        {Array.isArray(filteredChickenCategory) && filteredChickenCategory.map((item, index) => (
                            <div
                                onClick={() => { navigate(`/product/description/${item?.id}?product=true`) }}
                                key={index}
                                style={{ border: "1px solid rgb(210, 212, 215)" }}
                                className="min-h-[350px] cursor-pointer  md:max-h-[400px] hover:z-10 bg-white transition-all duration-300 ease-in-out hover:shadow-sm hover:shadow-[#8a2e25] hover:scale-105 relative  group"
                            >
                                {/* Sale Tag */}
                                {item?.discountAtOnce ? (
                                    <div className="bg-[#eb4b49] w-[70px] h-[25px] flex items-center justify-center py-1 rounded-sm absolute top-3 left-3">
                                        <p className="text-white text-[12px]">Sale {item?.discountAtOnce}%</p>
                                    </div>
                                ) : (
                                    country === "PK" ? (
                                        item?.IsDiscountedProductInPak ? (
                                            <div className="bg-[#eb4b49] w-[70px] h-[25px] flex items-center justify-center py-1 rounded-sm absolute top-3 left-3">
                                                <p className="text-white text-[12px]">Sale {item?.discountOfferinPak}%</p>
                                            </div>
                                        ) : (
                                            null
                                        )
                                    ) : (
                                        item?.IsDiscountedProductInUSA ? (
                                            <div className="bg-[#eb4b49] w-[70px] h-[25px] flex items-center justify-center py-1 rounded-sm absolute top-3 left-3">
                                                <p className="text-white text-[12px]">Sale {item?.discountOfferinUSA}%</p>
                                            </div>
                                        ) : (
                                            null
                                        )
                                    )
                                )}
                                <div className="absolute  top-3 right-3 flex md:flex-col gap-3 opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-opacity duration-300"
                                >
                                    <Tooltip
                                        arrow
                                        title="Add to wishlist"
                                        placement="left"
                                        componentsProps={{
                                            tooltip: {
                                                sx: {
                                                    backgroundColor: '#ffffff',
                                                    color: '#000000',
                                                    padding: '8px 12px',
                                                    borderRadius: 0,
                                                    boxShadow: 2,
                                                    fontSize: '13px'
                                                },
                                                className: 'custom-tooltip',
                                            },
                                        }}
                                    >
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                addToWishlist(item);
                                            }}
                                            className="bg-white cursor-pointer p-2 rounded-full shadow-md hover:bg-gray-100"
                                        >
                                            <Heart size={22} className="text-[#eb4b49]" />
                                        </button>

                                    </Tooltip>
                                    <Tooltip
                                        arrow
                                        title="View this product"
                                        placement="left"
                                        componentsProps={{
                                            tooltip: {
                                                sx: {
                                                    backgroundColor: '#ffffff',
                                                    color: '#000000',
                                                    padding: '8px 12px',
                                                    borderRadius: 0,
                                                    boxShadow: 2,
                                                    fontSize: '13px'
                                                },
                                                className: 'custom-tooltip',
                                            },
                                        }}
                                    >
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                navigate(`/product/description/${item?.id}?product=true`);
                                            }}
                                            className="bg-white cursor-pointer p-2 rounded-full shadow-md hover:bg-gray-100">
                                            <Eye size={22} className="text-[#1a1a1a]" />
                                        </button>
                                    </Tooltip>
                                </div>
                                {/* Product Image */}
                                <div className="flex max-h-[100%] items-center justify-center">
                                    {
                                        item?.ProductImages?.[0]?.imageUrl ? <img src={BASE_URL + (item?.ProductImages?.[0]?.imageUrl?.replace(/^\/+/, ""))} className=" min-h-[200px] max-h-[200px]" alt="product-image" /> :
                                            <div className="w-full min-h-[200px] bg-slate-200"></div>
                                    }
                                </div>

                                {/* Product Details */}
                                <div className="flex text-[#1a1a1a] py-4 px-3 justify-between items-center">
                                    <div className="flex flex-col max-w-[170px] gap-[5px]">
                                        <h1 className={`text-[17px] text-[18px] ${country === "PK" ? "text-[#a6392b]" : "text-[#65754d]"}  font-[600]`}>
                                            {item?.productName}
                                        </h1>
                                        <h1 className="text-[19px] font-[600] relative inline-block">
                                            {
                                                country === "PK"
                                                    ? `PKR ${item?.discountAtOnce
                                                        ? (item?.OriginalPricePak - (item?.OriginalPricePak * item?.discountAtOnce) / 100).toFixed(0)
                                                        : item?.IsDiscountedProductInPak
                                                            ? item?.PriceAfterDiscountPak
                                                            : item?.OriginalPricePak}`
                                                    : `$${item?.discountAtOnce
                                                        ? (item?.OriginalPriceUSA - (item?.OriginalPriceUSA * item?.discountAtOnce) / 100).toFixed(0)
                                                        : item?.IsDiscountedProductInUSA
                                                            ? item?.PriceAfterDiscountUSA
                                                            : item?.OriginalPriceUSA}`
                                            }
                                            <span className="text-[19px] text-[#8f8f8f] font-[500] ml-2 relative inline-block">
                                                {country === "PK"
                                                    ? (item?.discountAtOnce || item?.IsDiscountedProductInPak) && `PKR${item?.OriginalPricePak}`
                                                    : (item?.discountAtOnce || item?.IsDiscountedProductInUSA) && `$${item?.OriginalPriceUSA}`
                                                }
                                                {(item?.discountAtOnce || (country === "PK" ? item?.IsDiscountedProductInPak : item?.IsDiscountedProductInUSA)) && (
                                                    <svg
                                                        className="absolute left-0 top-1/2 w-full h-[2px] text-[#8f8f8f]"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <line x1="0" y1="1" x2="100%" y2="1" stroke="currentColor" strokeWidth="2" />
                                                    </svg>
                                                )}
                                            </span>
                                        </h1>
                                        <h1 className="font-[600]">Category: <span className="font-[400]">{item?.Category?.categoryName}</span></h1>
                                        <h1 className="font-[600]">
                                            Tags: <span className="font-[400]">
                                                {item?.productTags ? item.productTags.split(',').join(', ') : "N/A"}
                                            </span>
                                        </h1>
                                    </div>
                                    {(country === "PK"
                                        ? item?.quantityForPak > 0
                                        : item?.quantityForUSA > 0) ? (
                                        <Tooltip
                                            arrow
                                            title="Add to cart"
                                            placement="left"
                                            componentsProps={{
                                                tooltip: {
                                                    sx: {
                                                        backgroundColor: '#ffffff',
                                                        color: '#000000',
                                                        padding: '8px 12px',
                                                        borderRadius: 0,
                                                        boxShadow: 2,
                                                        fontSize: '13px'
                                                    },
                                                    className: 'custom-tooltip',
                                                },
                                            }}
                                        >
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    addToCart(item, country);
                                                }}
                                                className="bg-slate-200 absolute bottom-7 right-5 p-3 cursor-pointer rounded-full text-[#1a1a1a]"
                                            >
                                                <ShoppingCart size={20} />
                                            </button>

                                        </Tooltip>
                                    ) : (
                                        <div className="bg-red-100 absolute bottom-4 right-3 text-red-500 px-2 py-1 rounded-md text-sm font-medium">
                                            Out of stock
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="max-w-[1300px] my-2  h-full mx-auto py-4 md:py-2 px-6 md:px-8 text-white">
                <h1 className="font-[600] text-2xl text-[#1a1a1a] my-6 md:my-8 md:text-3xl">Alif Mutton Products</h1>
                <div className="grid gap-5 grid-cols-12">
                    <div className="grid col-span-12 md:col-span-8 gap-5 p-5 md:p-0  grid-cols-1 md:grid-cols-3">
                        {Array.isArray(filteredMuttonCategory) && filteredMuttonCategory.map((item, index) => (
                            <div
                                onClick={() => { navigate(`/product/description/${item?.id}?product=true`) }}
                                key={index}
                                style={{ border: "1px solid rgb(210, 212, 215)" }}
                                className="min-h-[350px] cursor-pointer  md:max-h-[400px] hover:z-10 bg-white transition-all duration-300 ease-in-out hover:shadow-sm hover:shadow-[#8a2e25] hover:scale-105 relative  group"
                            >
                                {/* Sale Tag */}
                                {item?.discountAtOnce ? (
                                    <div className="bg-[#eb4b49] w-[70px] h-[25px] flex items-center justify-center py-1 rounded-sm absolute top-3 left-3">
                                        <p className="text-white text-[12px]">Sale {item?.discountAtOnce}%</p>
                                    </div>
                                ) : (
                                    country === "PK" ? (
                                        item?.IsDiscountedProductInPak ? (
                                            <div className="bg-[#eb4b49] w-[70px] h-[25px] flex items-center justify-center py-1 rounded-sm absolute top-3 left-3">
                                                <p className="text-white text-[12px]">Sale {item?.discountOfferinPak}%</p>
                                            </div>
                                        ) : (
                                            null
                                        )
                                    ) : (
                                        item?.IsDiscountedProductInUSA ? (
                                            <div className="bg-[#eb4b49] w-[70px] h-[25px] flex items-center justify-center py-1 rounded-sm absolute top-3 left-3">
                                                <p className="text-white text-[12px]">Sale {item?.discountOfferinUSA}%</p>
                                            </div>
                                        ) : (
                                            null
                                        )
                                    )
                                )}
                                <div className="absolute  top-3 right-3 flex md:flex-col gap-3 opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-opacity duration-300"
                                >
                                    <Tooltip
                                        arrow
                                        title="Add to wishlist"
                                        placement="left"
                                        componentsProps={{
                                            tooltip: {
                                                sx: {
                                                    backgroundColor: '#ffffff',
                                                    color: '#000000',
                                                    padding: '8px 12px',
                                                    borderRadius: 0,
                                                    boxShadow: 2,
                                                    fontSize: '13px'
                                                },
                                                className: 'custom-tooltip',
                                            },
                                        }}
                                    >
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                addToWishlist(item);
                                            }}
                                            className="bg-white cursor-pointer p-2 rounded-full shadow-md hover:bg-gray-100"
                                        >
                                            <Heart size={22} className="text-[#eb4b49]" />
                                        </button>

                                    </Tooltip>
                                    <Tooltip
                                        arrow
                                        title="View this product"
                                        placement="left"
                                        componentsProps={{
                                            tooltip: {
                                                sx: {
                                                    backgroundColor: '#ffffff',
                                                    color: '#000000',
                                                    padding: '8px 12px',
                                                    borderRadius: 0,
                                                    boxShadow: 2,
                                                    fontSize: '13px'
                                                },
                                                className: 'custom-tooltip',
                                            },
                                        }}
                                    >
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                navigate(`/product/description/${item?.id}?product=true`);
                                            }}
                                            className="bg-white cursor-pointer p-2 rounded-full shadow-md hover:bg-gray-100">
                                            <Eye size={22} className="text-[#1a1a1a]" />
                                        </button>
                                    </Tooltip>
                                </div>
                                {/* Product Image */}
                                <div className="flex max-h-[100%] items-center justify-center">
                                    {
                                        item?.ProductImages?.[0]?.imageUrl ? <img src={BASE_URL + (item?.ProductImages?.[0]?.imageUrl?.replace(/^\/+/, ""))} className=" min-h-[200px] max-h-[200px]" alt="product-image" /> :
                                            <div className="w-full min-h-[200px] bg-slate-200"></div>
                                    }
                                </div>

                                {/* Product Details */}
                                <div className="flex text-[#1a1a1a] py-4 px-3 justify-between items-center">
                                    <div className="flex flex-col max-w-[170px] gap-[5px]">
                                        <h1 className={`text-[17px] text-[18px] ${country === "PK" ? "text-[#a6392b]" : "text-[#65754d]"}  font-[600]`}>
                                            {item?.productName}
                                        </h1>
                                        <h1 className="text-[19px] font-[600] relative inline-block">
                                            {
                                                country === "PK"
                                                    ? `PKR ${item?.discountAtOnce
                                                        ? (item?.OriginalPricePak - (item?.OriginalPricePak * item?.discountAtOnce) / 100).toFixed(0)
                                                        : item?.IsDiscountedProductInPak
                                                            ? item?.PriceAfterDiscountPak
                                                            : item?.OriginalPricePak}`
                                                    : `$${item?.discountAtOnce
                                                        ? (item?.OriginalPriceUSA - (item?.OriginalPriceUSA * item?.discountAtOnce) / 100).toFixed(0)
                                                        : item?.IsDiscountedProductInUSA
                                                            ? item?.PriceAfterDiscountUSA
                                                            : item?.OriginalPriceUSA}`
                                            }
                                            <span className="text-[19px] text-[#8f8f8f] font-[500] ml-2 relative inline-block">
                                                {country === "PK"
                                                    ? (item?.discountAtOnce || item?.IsDiscountedProductInPak) && `PKR${item?.OriginalPricePak}`
                                                    : (item?.discountAtOnce || item?.IsDiscountedProductInUSA) && `$${item?.OriginalPriceUSA}`
                                                }
                                                {(item?.discountAtOnce || (country === "PK" ? item?.IsDiscountedProductInPak : item?.IsDiscountedProductInUSA)) && (
                                                    <svg
                                                        className="absolute left-0 top-1/2 w-full h-[2px] text-[#8f8f8f]"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <line x1="0" y1="1" x2="100%" y2="1" stroke="currentColor" strokeWidth="2" />
                                                    </svg>
                                                )}
                                            </span>
                                        </h1>
                                        <h1 className="font-[600]">Category: <span className="font-[400]">{item?.Category?.categoryName}</span></h1>
                                        <h1 className="font-[600]">
                                            Tags: <span className="font-[400]">
                                                {item?.productTags ? item.productTags.split(',').join(', ') : "N/A"}
                                            </span>
                                        </h1>
                                    </div>
                                    {(country === "PK"
                                        ? item?.quantityForPak > 0
                                        : item?.quantityForUSA > 0) ? (
                                        <Tooltip
                                            arrow
                                            title="Add to cart"
                                            placement="left"
                                            componentsProps={{
                                                tooltip: {
                                                    sx: {
                                                        backgroundColor: '#ffffff',
                                                        color: '#000000',
                                                        padding: '8px 12px',
                                                        borderRadius: 0,
                                                        boxShadow: 2,
                                                        fontSize: '13px'
                                                    },
                                                    className: 'custom-tooltip',
                                                },
                                            }}
                                        >
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    addToCart(item, country);
                                                }}
                                                className="bg-slate-200 absolute bottom-7 right-5 p-3 cursor-pointer rounded-full text-[#1a1a1a]"
                                            >
                                                <ShoppingCart size={20} />
                                            </button>

                                        </Tooltip>
                                    ) : (
                                        <div className="bg-red-100 absolute bottom-4 right-3 text-red-500 px-2 py-1 rounded-md text-sm font-medium">
                                            Out of stock
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                    <div style={{ border: "1px solid rgb(210, 212, 215)" }} className="min-h-[560px] hover:z-10 bg-white transition-all duration-300 ease-in-out hover:shadow-sm hover:shadow-[#8a2e25] hover:scale-102 col-span-12 md:col-span-4">
                        <img src={Goat} className="w-full" alt="Category-img" />
                        <div className="p-3">
                            <h1 className={`font-[600] text-center text-2xl ${country === "PK" ? "text-[#8a2e25]" : "text-[#65754d]"} mt-6 mb-3`}>Premium Mutton, Packed with Flavor!</h1>
                            <p className="text-[#969696] text-[14px] mb-3 text-center max-w-[450px] mx-auto">Our mutton coms from naturally raised, well-nurtured goats, ensuring tender, juicy, and rich-flavoured meat. Perfect for curries, BBQ and traditional dishes!</p>
                            <button onClick={() => { navigate('/shop/mutton') }} className={`${country === "PK" ? "bg-[#8a2e25]" : "bg-[#65754d]"} text-white font-[500] p-3 mb-6 justify-center flex items-center w-full max-w-[400px] gap-4 mx-auto rounded-[30px]`}>Shop Fresh Mutton Now <ShoppingBag /></button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="max-w-[1300px] my-2  h-full mx-auto py-4 md:py-2 px-6 md:px-8 text-white">
                <h1 className="font-[600] text-2xl text-[#1a1a1a] my-6 md:my-8 md:text-3xl">Alif Beef Products</h1>
                <div className="grid gap-5 grid-cols-12">
                    <div style={{ border: "1px solid rgb(210, 212, 215)" }} className="min-h-[560px] hover:z-10 bg-white transition-all duration-300 ease-in-out hover:shadow-sm hover:shadow-[#8a2e25] hover:scale-102 col-span-12 md:col-span-4">
                        <img src={Cow} alt="Category-img" className="w-full" />
                        <div className="p-3">
                            <h1 className={`font-[600] text-center text-2xl ${country === "PK" ? "text-[#8a2e25]" : "text-[#65754d]"} mt-6 mb-3`}>Farm-Fresh Beef, Juciy & Nutritious</h1>
                            <p className="text-[#969696] text-[14px] mb-3 text-center max-w-[450px] mx-auto">Our beef comes from naturally fed, well-raised cattle, ensuring every cut is rich in flavor, incredibly tender and packed with essential nutrients. Perfect for you favourite dishes!</p>
                            <button onClick={() => { navigate('/shop/beef') }} className={`${country === "PK" ? "bg-[#8a2e25]" : "bg-[#65754d]"} text-white font-[500] p-3 justify-center flex items-center w-full max-w-[400px] gap-4 mx-auto rounded-[30px] mb-6`}>Shop Fresh Beef Now <ShoppingBag /></button>
                        </div>
                    </div>
                    <div className="grid col-span-12 md:col-span-8 gap-5 p-5 md:p-0 grid-cols-1 md:grid-cols-3">
                        {Array.isArray(filteredBeefCategory) && filteredBeefCategory.map((item, index) => (
                            <div
                                onClick={() => { navigate(`/product/description/${item?.id}?product=true`) }}
                                key={index}
                                style={{ border: "1px solid rgb(210, 212, 215)" }}
                                className="min-h-[350px] cursor-pointer  md:max-h-[400px] hover:z-10 bg-white transition-all duration-300 ease-in-out hover:shadow-sm hover:shadow-[#8a2e25] hover:scale-105 relative  group"
                            >
                                {/* Sale Tag */}
                                {item?.discountAtOnce ? (
                                    <div className="bg-[#eb4b49] w-[70px] h-[25px] flex items-center justify-center py-1 rounded-sm absolute top-3 left-3">
                                        <p className="text-white text-[12px]">Sale {item?.discountAtOnce}%</p>
                                    </div>
                                ) : (
                                    country === "PK" ? (
                                        item?.IsDiscountedProductInPak ? (
                                            <div className="bg-[#eb4b49] w-[70px] h-[25px] flex items-center justify-center py-1 rounded-sm absolute top-3 left-3">
                                                <p className="text-white text-[12px]">Sale {item?.discountOfferinPak}%</p>
                                            </div>
                                        ) : (
                                            null
                                        )
                                    ) : (
                                        item?.IsDiscountedProductInUSA ? (
                                            <div className="bg-[#eb4b49] w-[70px] h-[25px] flex items-center justify-center py-1 rounded-sm absolute top-3 left-3">
                                                <p className="text-white text-[12px]">Sale {item?.discountOfferinUSA}%</p>
                                            </div>
                                        ) : (
                                            null
                                        )
                                    )
                                )}
                                <div className="absolute  top-3 right-3 flex md:flex-col gap-3 opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-opacity duration-300"
                                >
                                    <Tooltip
                                        arrow
                                        title="Add to wishlist"
                                        placement="left"
                                        componentsProps={{
                                            tooltip: {
                                                sx: {
                                                    backgroundColor: '#ffffff',
                                                    color: '#000000',
                                                    padding: '8px 12px',
                                                    borderRadius: 0,
                                                    boxShadow: 2,
                                                    fontSize: '13px'
                                                },
                                                className: 'custom-tooltip',
                                            },
                                        }}
                                    >
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                addToWishlist(item);
                                            }}
                                            className="bg-white cursor-pointer p-2 rounded-full shadow-md hover:bg-gray-100"
                                        >
                                            <Heart size={22} className="text-[#eb4b49]" />
                                        </button>

                                    </Tooltip>
                                    <Tooltip
                                        arrow
                                        title="View this product"
                                        placement="left"
                                        componentsProps={{
                                            tooltip: {
                                                sx: {
                                                    backgroundColor: '#ffffff',
                                                    color: '#000000',
                                                    padding: '8px 12px',
                                                    borderRadius: 0,
                                                    boxShadow: 2,
                                                    fontSize: '13px'
                                                },
                                                className: 'custom-tooltip',
                                            },
                                        }}
                                    >
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                navigate(`/product/description/${item?.id}?product=true`);
                                            }}
                                            className="bg-white cursor-pointer p-2 rounded-full shadow-md hover:bg-gray-100">
                                            <Eye size={22} className="text-[#1a1a1a]" />
                                        </button>
                                    </Tooltip>
                                </div>
                                {/* Product Image */}
                                <div className="flex max-h-[100%] items-center justify-center">
                                    {
                                        item?.ProductImages?.[0]?.imageUrl ? <img src={BASE_URL + (item?.ProductImages?.[0]?.imageUrl?.replace(/^\/+/, ""))} className=" min-h-[200px] max-h-[200px]" alt="product-image" /> :
                                            <div className="w-full min-h-[200px] bg-slate-200"></div>
                                    }
                                </div>

                                {/* Product Details */}
                                <div className="flex text-[#1a1a1a] py-4 px-3 justify-between items-center">
                                    <div className="flex flex-col max-w-[170px] gap-[5px]">
                                        <h1 className={`text-[17px] text-[18px] ${country === "PK" ? "text-[#a6392b]" : "text-[#65754d]"}  font-[600]`}>
                                            {item?.productName}
                                        </h1>
                                        <h1 className="text-[19px] font-[600] relative inline-block">
                                            {
                                                country === "PK"
                                                    ? `PKR ${item?.discountAtOnce
                                                        ? (item?.OriginalPricePak - (item?.OriginalPricePak * item?.discountAtOnce) / 100).toFixed(0)
                                                        : item?.IsDiscountedProductInPak
                                                            ? item?.PriceAfterDiscountPak
                                                            : item?.OriginalPricePak}`
                                                    : `$${item?.discountAtOnce
                                                        ? (item?.OriginalPriceUSA - (item?.OriginalPriceUSA * item?.discountAtOnce) / 100).toFixed(0)
                                                        : item?.IsDiscountedProductInUSA
                                                            ? item?.PriceAfterDiscountUSA
                                                            : item?.OriginalPriceUSA}`
                                            }
                                            <span className="text-[19px] text-[#8f8f8f] font-[500] ml-2 relative inline-block">
                                                {country === "PK"
                                                    ? (item?.discountAtOnce || item?.IsDiscountedProductInPak) && `PKR${item?.OriginalPricePak}`
                                                    : (item?.discountAtOnce || item?.IsDiscountedProductInUSA) && `$${item?.OriginalPriceUSA}`
                                                }
                                                {(item?.discountAtOnce || (country === "PK" ? item?.IsDiscountedProductInPak : item?.IsDiscountedProductInUSA)) && (
                                                    <svg
                                                        className="absolute left-0 top-1/2 w-full h-[2px] text-[#8f8f8f]"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <line x1="0" y1="1" x2="100%" y2="1" stroke="currentColor" strokeWidth="2" />
                                                    </svg>
                                                )}
                                            </span>
                                        </h1>
                                        <h1 className="font-[600]">Category: <span className="font-[400]">{item?.Category?.categoryName}</span></h1>
                                        <h1 className="font-[600]">
                                            Tags: <span className="font-[400]">
                                                {item?.productTags ? item.productTags.split(',').join(', ') : "N/A"}
                                            </span>
                                        </h1>
                                    </div>
                                    {(country === "PK"
                                        ? item?.quantityForPak > 0
                                        : item?.quantityForUSA > 0) ? (
                                        <Tooltip
                                            arrow
                                            title="Add to cart"
                                            placement="left"
                                            componentsProps={{
                                                tooltip: {
                                                    sx: {
                                                        backgroundColor: '#ffffff',
                                                        color: '#000000',
                                                        padding: '8px 12px',
                                                        borderRadius: 0,
                                                        boxShadow: 2,
                                                        fontSize: '13px'
                                                    },
                                                    className: 'custom-tooltip',
                                                },
                                            }}
                                        >
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    addToCart(item, country);
                                                }}
                                                className="bg-slate-200 absolute bottom-7 right-5 p-3 cursor-pointer rounded-full text-[#1a1a1a]"
                                            >
                                                <ShoppingCart size={20} />
                                            </button>

                                        </Tooltip>
                                    ) : (
                                        <div className="bg-red-100 absolute bottom-4 right-3 text-red-500 px-2 py-1 rounded-md text-sm font-medium">
                                            Out of stock
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Testimonials />
            <NewsLetter color='white' />
        </main>
    );
}

export default LandingPage;
